import React, {Component} from 'react';
import Api from "../../utils/Api";
import moment from 'moment';
import BiaxialBarChart from "../../utils/charts/BiaxialBarChart";
import PropTypes from "prop-types";
import LoadingSplash from "../../globalComponents/LoadingSplash";
import TimeRange from "../../utils/TimeRange";

class PreviewReportStitches extends Component {

    static propTypes = {
        baseData: PropTypes.object.isRequired,
        machine: PropTypes.object.isRequired,
    };

    static defaultProps = {
        height: 250,
        width: null,
    };

    constructor(props) {

        super(props);

        this.api = new Api();

        let tr = new TimeRange();
        let from = moment().subtract(14, 'days');

        tr.setRange(from, moment());

        this.state = {
            timeRange: tr, // TimeRange
            requestedParams: null, // stringified parameters to prevent double-request
            chartAreaWidth: null,
            chartData: null // chartdata from server
        };

        this.translate = this.props.baseData.translate;
        this.resizeTimer = null;
        this.domRef = React.createRef();

        this.requestReport = this.requestReport.bind(this);
        this.reportResult = this.reportResult.bind(this);
        this.updateDimensions = this.updateDimensions.bind(this);

    };

    componentWillMount() {

        this.requestReport();

    }

    componentDidMount() {

        this.updateDimensions();

        window.addEventListener("resize", this.updateDimensions);

    }

    componentWillUnmount() {

        window.removeEventListener("resize", this.updateDimensions);

    }

    updateDimensions() {

        let adjust = () => {
            try {
                this.resizeTimer = 0;
                // try to adjust chart width
                let newWidth = this.domRef.current && this.domRef.current.offsetWidth > 100 ? this.domRef.current.offsetWidth : 100;
                if (newWidth !== this.state.chartAreaWidth) {
                    this.setState({chartAreaWidth: newWidth});
                }
            } catch (e) {
            }
        };

        if (this.resizeTimer === null) adjust();

        if (this.resizeTimer > 0) window.clearTimeout(this.resizeTimer);

        this.resizeTimer = window.setTimeout(adjust, 75);

    }

    requestReport() {

        const tr = this.state.timeRange;
        const dateFrom = tr ? tr.getFromMoment() : null;
        const dateTill = tr ? tr.getTillMoment() : null;
        const machineId = this.props.machine ? this.props.machine.machine_id : null;

        // Check, if all data is set
        if (!dateFrom || !dateTill || !machineId) return null;

        const params = {
            machine: machineId,
            id_company: this.props.baseData.companies.currentCompany.id,
            from: dateFrom.unix(),
            till: dateTill.unix(),
            shift: null,
            timezone: this.props.baseData.companies.currentCompany.timezone,
            showSubThreadbreaks: true,
            interval: 'hours'
        };

        const sParams = JSON.stringify(params);

        if (sParams === this.state.requestedParams) return;

        this.setState({
            requestedParams: sParams
        });

        this.api.request('GetStitchHistory', params, this.reportResult, null);
        this.createChartArray(tr);

    }

    reportResult(result) {

        // Result-daten in Grid einsortieren
        const currentGrid = this.state.chartData;

        if (!currentGrid || !result) return;

        const tr = this.state.timeRange;
        const gran = tr.getDisplayGranularity();

        //console.debug("reportResult", currentGrid, result);
        // API might return data directly or nested in result property
        const resultData = result.result ? result.result : result;

        // Create a new grid with new objects to avoid mutation of read-only state
        const grid = currentGrid.map(row => ({...row}));

        for (let ix in resultData) {
            let resMoment = moment(ix, 'X').format(gran.label);

            for (let ix2 in grid) {
                let dataRow = grid[ix2];

                if (dataRow.name === resMoment) {
                    let resultRow = resultData[ix];

                    dataRow.st += resultRow.st;
                    dataRow.tb += resultRow.tb;
                    break;
                }
            }
        }

        this.setState({
            chartData: grid
        });

    }

    // Aktuelles Chart mit leeren Werten fuellen
    createChartArray(timeRange) {

        const gran = timeRange ? timeRange.getDisplayGranularity() : null;
        const till = timeRange.getTillMoment().unix();
        const grid = [];

        let t = timeRange.getFromMoment().clone();

        while (true) {
            grid.push({
                name: t.format(gran.label), st: 0, tb: 0
            });

            t = t.add(gran.duration);

            if (t.unix() > till) break;
            if (grid.length > 1000) break; // Safety break
        }

        this.setState({
            chartData: grid
        });

    }

    chartClick1(activeIndex, key) {

        // TODO message to parent

    }

    render() {

        if (this.state.chartData === null) return null;
        if (!this.state.chartData || !this.state.chartAreaWidth) {
            return (
                <div className='display col-xs-12' ref={this.domRef}>
                    <LoadingSplash color={'dark'}/>
                </div>
            );
        }

        const width = (this.props.width) ? this.props.width : this.state.chartAreaWidth;

        return (
            <div className='display previewChart col-xs-12' ref={this.domRef}>
                <BiaxialBarChart
                    data={this.state.chartData}
                    label1={this.translate('stitches')}
                    label2={this.translate('threadbreaks')}
                    translate={this.translate}
                    width={width}
                    height={this.props.height}
                    handleClick={this.chartClick1}
                />
            </div>
        );

    }

}

export default PreviewReportStitches;
